import { GridColDef } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { expertiseService } from 'features/cost-analysis/team/expertises/api/expertise.service';
import { RoleColumns } from '../roles';

function RoleNameByRoleList() {
  const translationPrefix = 'pages.roles.list';
  const { t } = useTranslation();

  const columns: GridColDef[] = RoleColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid columns={columns} service={expertiseService} />
    </TenantPage>
  );
}

export default RoleNameByRoleList;
